<template>
    <form-template @submit="proceed">
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Phone Number</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-input
                type="number"
                placeholder="Input Phone Number"
                @nativeInput="debouncedGetTelco"
                v-model="data.airtime_phone_number"
                required
            >
                <template v-if="loadingTelco" v-slot:append>
                    <img src="@/assets/svg/load.svg" alt="loader" class="w-6" />
                </template>
            </biller-input>
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Carrier Network</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <div class="grid grid-cols-4 gap-3 w-full">
                <template v-if="telcos.length">
                    <div class="col-span-2 md:col-span-1" v-for="tel in telcos" :key="tel.product">
                        <biller-radio
                            @select="data.network = tel.product.toLowerCase()"
                            :value="tel.product"
                            :active="data.network === tel.product.toLowerCase()"
                            class="flex items-center justify-center"
                        >
                            <div class="flex items-center justify-center">
                                <img :src="require(`@/assets/svg/telcos/${tel.product}.svg`)" class="mx-auto pr-3" />
                                <p
                                    :class="
                                        `text-sm ${
                                            data.network === tel.product.toLowerCase() ? 'text-purple' : 'text-grey-300'
                                        }`
                                    "
                                >
                                    {{ tel.product }}
                                </p>
                            </div>
                        </biller-radio>
                    </div>
                </template>
                <template v-else>
                    <div class="col-span-2 md:col-span-1" v-for="index in 4" :key="index">
                        <telco-skeleton-loader />
                    </div>
                </template>
            </div>
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Amount</p>
        </div>
        <div class="col-span-4 md:col-span-3 relative">
            <biller-input
                placeholder="Input Airtime Amount"
                largeValue
                type="text"
                :value="input"
                @input="updateAmount"
                required
            >
                <template v-slot:append>
                    <img src="@/assets/svg/naira-icon.svg" alt="Nigerian Naira icon" />
                </template>
            </biller-input>
        </div>
    </form-template>
</template>

<script>
import telco from '@/mixins/telco'
import { formatAmount } from '@/util/formatAmount'
export default {
    name: 'AirtimeForm',
    mixins: [telco],
    data() {
        return {
            loadingTelco: false,
            data: {
                email: '',
                phone: '',
                country_id: '',
                network: '',
                airtime_phone_number: '',
                deposit_type: '',
                amount: '',
            },
            input: '',
        }
    },

    methods: {
        updateAmount(val) {
            this.input = val.replace(/[^\d]/g, '')
            this.$forceUpdate()
        },

        proceed(val) {
            const fullData = Object.assign(this.data, val)
            this.$emit('proceed', fullData)
        },
    },

    watch: {
        input: function(newValue) {
            let val = newValue
                .toString()
                .split(',')
                .join('')
            this.data.amount = parseInt(val)
            this.input = formatAmount(val)
        },
    },
}
</script>

<style></style>
